import React from 'react';

import { DEALER_AGREEMENT_DOCUMENT, type DealerAgreementBlock } from '@/const/dealerAgreementClauses';

/** `~~…~~` 구간은 화면에 출력하지 않음 */
const AgreementInlineText = ({ text }: { text: string }) => {
  const visible = text
    .split(/~~/)
    .filter((_, i) => i % 2 === 0)
    .join('');
  return <>{visible}</>;
};

const BlockView = ({ block }: { block: DealerAgreementBlock }) => {
  if (block.kind === 'p') {
    return (
      <p className="text-sm text-gray-8 leading-[1.65] mb-3 last:mb-0">
        <AgreementInlineText text={block.text} />
      </p>
    );
  }
  if (block.kind === 'h3') {
    return (
      <h3 className="text-sm font-bold text-gray-9 mt-5 mb-2 first:mt-0">
        <AgreementInlineText text={block.text} />
      </h3>
    );
  }
  return (
    <ul className="list-disc pl-5 text-sm text-gray-8 leading-[1.65] space-y-2 mb-3">
      {block.items.map((item, i) => (
        <li key={i}>
          <AgreementInlineText text={item} />
        </li>
      ))}
    </ul>
  );
};

const DealerAgreementDocument = () => {
  const { title, sections } = DEALER_AGREEMENT_DOCUMENT;

  return (
    <article className="text-gray-8">
      <h1 className="text-lg font-bold text-gray-9 leading-snug mb-8">{title}</h1>
      {sections.map((section, si) => (
        <section key={si} className="mb-8 last:mb-0">
          <h2 className="text-base font-bold text-gray-9 mb-3">
            <AgreementInlineText text={section.heading} />
          </h2>
          <div className="pl-0">
            {section.blocks.map((block, bi) => (
              <BlockView key={bi} block={block} />
            ))}
          </div>
        </section>
      ))}
    </article>
  );
};

export default DealerAgreementDocument;
